import type { Schema } from '@/shared/api/contract';
import { api } from '@/shared/api/client';

import type { LoginPayload, PasswordChange, User } from './types';

/** Query key of the current session. Everything auth related is invalidated through it. */
export { sessionQueryKey } from '@/shared/session/currentUser';

export const authApi = {
  /** Sets the httpOnly cookie. The token never reaches JavaScript. */
  login: (payload: LoginPayload): Promise<User> => api.post<User>('/api/auth/login', payload),

  logout: (): Promise<void> => api.post<void>('/api/auth/logout'),

  // `GET /api/auth/me` lives in `sessionQueryOptions` (shared/session): the guard and
  // every reader of the session share that one request and its options.

  changePassword: (payload: PasswordChange): Promise<User> =>
    api.post<User>('/api/profile/password', payload),

  /** Who an invitation is for and how long it has left, without burning it. 404 when it
   * does not exist, was used or expired. */
  peekInvite: (token: string): Promise<Schema<'InvitePeek'>> =>
    api.get<Schema<'InvitePeek'>>(`/api/auth/invite/${encodeURIComponent(token)}`),

  /** Does not open a session (the person logs in afterwards with the new password),
   * so the API answers plain `UserRead`, not `SessionRead`. */
  acceptInvite: (token: string, password: string): Promise<Schema<'UserRead'>> =>
    api.post<Schema<'UserRead'>>(`/api/auth/invite/${encodeURIComponent(token)}`, { password }),
};
